var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$style.formContainer },
    [
      _c(
        "transition",
        { attrs: { name: _vm.$style.fade } },
        [
          _c(
            "LoginCard",
            { key: "resetPassword", attrs: { header: "User Password Reset" } },
            [
              _c("Alert", {
                model: {
                  value: _vm.errorMessage,
                  callback: function ($$v) {
                    _vm.errorMessage = $$v
                  },
                  expression: "errorMessage",
                },
              }),
              _vm._v(" "),
              _c("ResetPassword", {
                ref: _vm.formRef,
                attrs: {
                  clientType: _vm.clientType,
                  isLoading: _vm.isLoading,
                  form: _vm.form,
                  submit: _vm.submit,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("LogoIcon"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }